<template>
 <div>
  <div v-for="light in lightning" :key="light.id" class="pb-4">
    <p class="text-sm pt-2 pb-2">Zubehör</p>

    <div class="flex items-center">
      <router-link :to="{ name: 'product', params: { id: lightId } }" class="flex items-center">
        <img class="w-20 mr-4" :src="light.image" alt="Light Img" />
        <div>
          <p class="text-base">{{ light.name }} </p>
          <div class="my-1" v-if="light.sale_price > 0">
            <p class="font-medium line-through text-red-500">{{ light.price | formatNumber }}</p>
            <p class="font-medium text-teal-400 text-lg">{{ light.sale_price | formatNumber }}</p>
          </div>
          <div v-else>
            <p class="font-medium text-xl">{{ light.price }} €</p>
          </div>
        </div>
      </router-link>
      <div class="ml-auto">
        <input
          @click="addLighting(lightning)"
          class="form-checkbox h-6 w-6 ml-4 mt-1"
          type="checkbox"
          name
          id
        />
      </div>
    </div>
  </div>
</div>
  <!-- <div v-else></div> -->
</template>

<script>
import mixins from "@/mixins/mixins";

export default {
  props: {
    lightning: Array,
    lightId: Number
  },
  mixins: [mixins],

  data() {
    return {
      lighting: true,


    };
  },
};
</script>

<style scoped>

@media(max-width:470px){
  .text-base{
    font-size: 14px;
  }
}

</style>